import { exerciseStatsQueryOptions } from '@/src/queries/activity-queries'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'
import { STATISTICS_CARD_PLACEHOLDER_VALUE } from './statistics-card.constants'

export function BestStreakMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const exerciseStatsQuery = useSuspenseQuery(exerciseStatsQueryOptions)
  const bestStreakWeeks = exerciseStatsQuery.data.longestStreak
  const value =
    bestStreakWeeks == null
      ? STATISTICS_CARD_PLACEHOLDER_VALUE
      : `${bestStreakWeeks} ${t('statistics:week_unit', {
          count: bestStreakWeeks,
        })}`

  return (
    <StatisticsMetricCard
      id="best-streak"
      title={t('statistics:metric_best_streak_title')}
      value={value}
      timeframe={t('statistics:timeframe_since_start')}
      iconName="best-streak"
    />
  )
}
